import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const LinkText = styled.a`
  text-decoration: underline;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.main};
`
